import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "d-flex justify-content-around" }
const _hoisted_2 = { class: "d-flex flex-column align-items-center justify-content-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "cerchioCalendar available" }, null, -1)
const _hoisted_4 = { class: "d-flex flex-column align-items-center justify-content-center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "cerchioCalendar prenotato" }, null, -1)
const _hoisted_6 = { class: "d-flex flex-column align-items-center justify-content-center" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "cerchioCalendar full" }, null, -1)
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "day" }
const _hoisted_10 = { class: "dayDetails" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_calendar = _resolveComponent("calendar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", null, [
          _createVNode(_component_localized_text, {
            localizedKey: "Libero",
            text: "Libero"
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", null, [
          _createVNode(_component_localized_text, {
            localizedKey: "Prenotato",
            text: "Prenotato"
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", null, [
          _createVNode(_component_localized_text, {
            localizedKey: "Pieno",
            text: "Pieno"
          })
        ])
      ])
    ]),
    _createVNode(_component_calendar, {
      onChanged: _ctx.getCalendarData,
      "show-navigator": true,
      "show-mode-changer": false,
      class: "month",
      startMode: "month"
    }, {
      default: _withCtx((calData) => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(calData.days, (day, i) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["calendarDay calendarDayDashboard", _ctx.getDayClasses(day)]),
            key: i,
            onClick: ($event: any) => (_ctx.checkDate(day.date))
          }, [
            _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$filters.date(day.date, "DD")), 1),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", null, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Liberi:",
                  text: "Liberi:"
                }),
                _createTextVNode(" " + _toDisplayString(_ctx.getAvailsOfDate(day)), 1)
              ]),
              _createElementVNode("div", null, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Prenotazioni:",
                  text: "Prenotazioni:"
                }),
                _createTextVNode(" " + _toDisplayString(_ctx.getPrenotazioniOfDate(day)), 1)
              ])
            ])
          ], 10, _hoisted_8))
        }), 128))
      ]),
      _: 1
    }, 8, ["onChanged"])
  ], 64))
}